// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconPieChart = createRemixIcon('IconPieChart', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M13.25 0h1A9.75 9.75 0 0 1 24 9.75v1H13.25zM2.5 14.25a7.25 7.25 0 0 1 6-7.143V15.5h8.393A7.25 7.25 0 0 1 2.5 14.25M9.75 4.5C4.365 4.5 0 8.865 0 14.25S4.365 24 9.75 24s9.75-4.365 9.75-9.75V13H11V4.5z\" clip-rule=\"evenodd\"/>");
